import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from 'src/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'rounded-sm border-primary-hover bg-primary-default text-primary-foreground',
        secondary:
          'rounded-sm border-secondary-hover bg-secondary-default text-secondary-foreground',
        destructive:
          'rounded-sm border-error-hover bg-error-default text-error-foreground',
        warning:
          'rounded-sm border-warning-hover bg-warning-default text-warning-foreground',
        outline: 'rounded-sm border-border-default text-layout-foreground',
        info: 'rounded-sm border-info-hover bg-info-default text-info-foreground',
        pillsDefault:
          'rounded-full border-transparent bg-primary-default text-primary-foreground',
        pillsSecondary:
          'rounded-full border-transparent bg-secondary-default text-secondary-foreground',
        pillsDestructive:
          'rounded-full border-transparent bg-error-default text-error-foreground',
        pillsWarning:
          'rounded-full border-transparent bg-warning-default text-warning-foreground',
        pillsOutline:
          'rounded-full border-border-default text-layout-foreground',
        pillsInfo:
          'rounded-full border-transparent bg-info-default text-info-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
